import React, { useState, useEffect, useCallback, useReducer } from "react";
import ReactModal from "react-modal";

const types = {
    setModal: "SET_MODAL"
};

const initState = {
    modals: new Map()
};

const reducer = (state: any, action: { type: string; payload: any }) => {
    /* istanbul ignore else */ // <- This line is needed for coverage reporter so it can avoid checking the else path
    if (action.type === types.setModal) {
        const modalName = action.payload.modalName;
        const modalProps = action.payload.modalProps;

        state.modals.set(modalName, modalProps);
    }
    return { ...state };
};

const Modal = (props: any) => {
    const [state, dispatch] = useReducer(reducer, initState);
    const [priorZIndex, setPriorZIndex] = useState(1);

    const findFirstOpen = useCallback(() => {
        for (const [key, value] of state.modals.entries()) {
            /* istanbul ignore else */ // <- This line is needed for coverage reporter so it can avoid checking the else path
            if (value.isOpen === true) {
                return key;
            }
        }
    }, [state.modals]);

    const resetZIndexes = useCallback(() => {
        for (const [key, value] of state.modals.entries()) {
            dispatch({
                type: types.setModal,
                payload: {
                    ...{
                        modalName: key,
                        modalProps: {
                            ...value,
                            ...{
                                style: { overlay: { zIndex: 1 } }
                            }
                        }
                    }
                }
            });
        }
    }, [state.modals]);

    useEffect(() => {
        // Reset all existing modal zIndexes
        resetZIndexes();

        // Add/Update existing modal
        dispatch({
            type: types.setModal,
            payload: {
                modalName: props.modalName,
                modalProps: {
                    ...props,
                    ...{
                        style: {
                            overlay: {
                                zIndex: 1
                            }
                        }
                    }
                }
            }
        });

        // Set prior zIndex to the first opened modal
        setPriorZIndex(findFirstOpen() === props.modalName ? 2 : 1);
    }, [props, findFirstOpen, resetZIndexes]);

    return (
        <ReactModal
            {...state.modals.get(props.modalName)}
            style={{
                overlay: { zIndex: priorZIndex }
            }}
        ></ReactModal>
    );
};

export default Modal;
